module.exports = __webpack_public_path__ + "static/media/hot_tub.154464da.svg";